export default {
  spaServiceLabel: "Trattamento spa",
  fitnessClassLabel: "Lezione di fitness",
  selectedTime: "Orario selezionato",

  tbd: "Da definire",
  durationUnavailable: "Durata non disponibile",
  "checkoutCancelled": "Pagamento annullato",
  "checkoutCancelledHelp": "La procedura di pagamento non completata è chiusa. Puoi tornare indietro e scegliere un’altra modalità di pagamento.",
  "backToBooking": "Torna alla prenotazione",

  "recoveryCheck": "Verifica l’esito della prenotazione",
  "recoveryChecking": "Verifica dell’esito…",
  "recoveryExplain": "Verifica l’esito prima di riprovare. Le eventuali procedure di pagamento non completate verranno chiuse in modo sicuro.",
  "recoveryPending": "L’esito è ancora in attesa. Verifica di nuovo prima di avviare un’altra prenotazione.",
  "recoveryHelp": "Il pagamento richiede l’intervento del club. Contatta il club prima di prenotare di nuovo.",

  "noPayment": "Nessun pagamento richiesto",
  "spaSuccess": "Il tuo trattamento è prenotato",
  "fitnessSuccess": "La tua prenotazione è confermata",
  "racquetSuccess": "Il tuo campo è prenotato",
  "reservationConfirmed": "Prenotazione confermata",
  "welcome": "È tutto pronto. Ti aspettiamo.",
  "viewBooking": "Visualizza la prenotazione",
  "backHome": "Torna alla pagina iniziale",
  "reference": "Riferimento prenotazione",
  "paymentLabel": "Pagamento",
  "confirmed": "Confermato",
  "guests": "Ospiti",
  "alreadyBooked": "Hai già questo appuntamento. Controlla le tue prossime prenotazioni.",
  "popup": "Consenti le finestre popup per proseguire con il pagamento sicuro.",
  "accounting": "Non è stato possibile completare la prenotazione perché la sincronizzazione del conto non è riuscita. Riprova.",
  "fitnessGeneric": "Non è stato possibile completare la richiesta. Riprova o contatta il club.",
  "fitnessAlreadyBooked": "Sei già prenotato per questa lezione a questo orario.",
  "fitnessAccounting": "Non è stato possibile completare la prenotazione. Riprova o contatta il club.",

  "total": "Totale",
  "confirm": "Conferma la prenotazione",
  "confirming": "Conferma in corso…",
  "checking": "Verifica disponibilità…",
  "chooseTime": "Torna indietro e scegli un orario disponibile.",
  "pending": "Controlla il pagamento o le tue prossime prenotazioni prima di avviare un’altra prenotazione.",
  "unknown": "Non è stato possibile verificare l’esito della prenotazione. Controlla le tue prossime prenotazioni o contatta il club prima di riprovare.",
  "unavailable": "Questo orario non è più disponibile. Scegline un altro.",
  "invalid": "Questo orario non è più disponibile. Torna indietro e scegline un altro.",
  "failed": "Al momento non è possibile confermare questa prenotazione.",
  "previewFailed": "Non è possibile verificare questo orario. Torna indietro e riprova.",
  "serviceFailed": "Non è possibile caricare questo trattamento. Torna indietro e riprova.",
  "backTimes": "Torna agli orari disponibili",
  "backClasses": "Torna alle lezioni",
  "review": "Rivedi e conferma",
  "attendee": "Partecipante",
  "payer": "Pagante",
  "member": "Socio",
  "details": "Dettagli della prenotazione",
  "class": "Lezione",
  "date": "Data",
  "time": "Ora",
  "location": "Luogo",
  "confirmClass": "Conferma la tua lezione",
  "fitnessBooking": "Prenotazione fitness",
  "session": "Sessione",
  "payment": "Modalità di pagamento",
  "account": "Conto socio",
  "statement": "Gli addebiti vengono aggiunti al tuo estratto conto socio.",
  "secure": "Paga ora in modo sicuro.",
  "guestPay": "L’ospite pagherà",
  "guestLink": "Invia all’ospite un link di pagamento sicuro via e-mail. Il tuo conto socio non verrà addebitato."
}
